if (!customElements.get("custom-modal")) {
  // Generic modal element. Toggle it with show()/hide()/toggle(), or open it
  // from any element carrying data-modal-id="<id>".
  class Modal extends HTMLElement {
    constructor() {
      super();
      this.registerListeners();
    }

    registerListeners() {
      // Backdrop and close button both carry data-modal-close.
      this.querySelectorAll("[data-modal-close]").forEach((el) =>
        el.addEventListener("click", () => this.hide()),
      );
    }

    show() {
      if (this.dataset.show === "transition") return;
      this.dataset.show = "transition";
      setTimeout(() => {
        this.dataset.show = "true";
        this.dispatchEvent(new CustomEvent("modal:show", { bubbles: true }));
      }, 10);
    }

    hide() {
      if (this.dataset.show === "transition") return;
      this.dataset.show = "transition";
      setTimeout(() => {
        this.dataset.show = "false";
        this.dispatchEvent(new CustomEvent("modal:hide", { bubbles: true }));
      }, 300);
    }

    toggle() {
      if (this.dataset.show === "true") {
        this.hide();
      } else {
        this.show();
      }
    }
  }

  customElements.define("custom-modal", Modal);

  // Any element with data-modal-id (other than a modal itself) opens the
  // matching custom-modal[data-modal-id="<id>"] when clicked.
  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-modal-id]");
    if (!opener || opener.tagName === "CUSTOM-MODAL") return;
    const selector = `custom-modal[data-modal-id="${CSS.escape(opener.dataset.modalId)}"]`;
    // The same id can appear more than once on a page — e.g. a product card
    // shown both in a (hidden) megamenu dropdown and in the visible grid. Open
    // the matching modal closest to the clicked opener, walking up its
    // ancestors, so we never target a copy inside a display:none subtree.
    let modal = null;
    for (let scope = opener.parentElement; scope && !modal; scope = scope.parentElement) {
      modal = scope.querySelector(selector);
    }
    (modal || document.querySelector(selector))?.show();
  });
}
